import axios from "axios";
import { environment } from "src/environments/environment";
import { find } from 'underscore'
import { Network } from "@capacitor/network";

export class MiscHelper {
    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static async getAssetUrl(path: string) {
        let url = `${environment.assets_url}${path}`;
        if (environment.is_online) {
            let params = this.getCookieValue('storage_token');
            let extension = params.replace(/"/g, "");
            url = `${url}?${extension}`;
        }
        return url;
    }

    static getAssetUrlSync(path: string) {
        let url = `${environment.assets_url}${path}`;
        if (environment.is_online) {
            let params = this.getCookieValue('storage_token');
            let extension = params.replace(/"/g, "");
            url = `${url}?${extension}`;
        }
        return url;
    }

    static async getJson(path: string): Promise<any> {
        try {
            let url = `${environment.assets_url}${path}`;
            if (environment.is_online) {
                let params = this.getCookieValue('storage_token');
                let extension = params.replace(/"/g, "");
                url = `${url}?${extension}`;
            }
            let result = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return result.data;
        } catch (e) {
            console.log(`MiscHelper.getJson failed`, e);
            return null;
        }
    }

    static async getText(path: string): Promise<string> {
        try {
            let url = `${environment.assets_url}${path}`;
            if (environment.is_online) {
                let params = this.getCookieValue('storage_token');
                let extension = params.replace(/"/g, "");
                url = `${url}?${extension}`;
            }
            let result = await axios.get(url);
            return result.data;
        } catch (e) {
            console.log(`MiscHelper.getText failed`, e);
            return null;
        }
    }

    static async checkCookie() {
        let is_recheck = true
        let retry_count = 0
        while (is_recheck) {
            if (document.cookie) {
                is_recheck = false
            } else {
                if (retry_count < 10) {
                    await this.sleep(1000)
                    console.log(`rechecking ${retry_count}`)
                    retry_count++
                } else {
                    is_recheck = false
                }
            }
        }
    }

    static getCookieValue(name) {
        const cookiestring = RegExp(name + "=[^;]+").exec(document.cookie);
        return cookiestring.toString().replace(/^[^=]+./, "");
    }

    static getFileTypeFromMime(content_type: string) {
        const mappings = [
            {
                name: 'image',
                types: ['image/gif', 'image/jpeg', 'image/png', 'image/bmp']
            },
            {
                name: 'video',
                types: ['video/mpeg', 'video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-sgi-movie', 'application/mp4']
            }
        ];

        const type = find(mappings, item => {
            return item.types.indexOf(content_type) > -1
        });
        if (type) {
            return type.name;
        }
    }

    static async blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    static async isConnected() {
        const status = await Network.getStatus();
        return ['wifi', 'cellular'].indexOf(status.connectionType) > -1 && status.connected;
    }

    static groupArray(data: any[], group_length: number) {
        const result = []
        let group_index = -1
        for (let index in data) {
            const item = data[index]
            if (parseInt(index) % group_length === 0) {
                group_index++
                result[group_index] = []

            }
            result[group_index].push(item)
        }
        return [...result]
    }
}